import { WorkflowConfiguration } from '@blk/awt-aladdinwealthserver';
import { AxiosResponse } from 'axios';
import { awApiWithPkg } from './Base';

export type SnoozeSettings = {
  enableSnooze: boolean;
  includeSnoozeLabel: string;
  hideSnoozeLabel: string;
  filterSnoozeLabel: string;
  filterNullSnoozeLabel: string;
  statusChangeSnoozeWarning?: string;
  snoozeLabelMap: SnoozeLabels | undefined;
};

export interface SnoozeLabels {
  SNOOZE: string | undefined;
  SNOOZE_UNTIL: string | undefined;
  SNOOZED: string | undefined;
  SNOOZED_UNTIL: string | undefined;
  UNSNOOZE: string | undefined;
}

export function getWorkflowConfig(pkg: string): Promise<AxiosResponse<WorkflowConfiguration>> {
  const path = '/workflow/config';
  return awApiWithPkg.get(path, { params: { pkg } });
}
